export default __webpack_public_path__ + "static/media/BA.e5789292.svg";